(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-video-strip"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectors = {
      root: '.product-video-strip',
      track: '[data-video-strip-track]'
    };

    const updateStrip = (root) => {
      const track = root.querySelector(selectors.track);
      if (!track) return;

      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const isScrollable = maxScroll > 1;

      root.classList.toggle('product-video-strip--scrollable', isScrollable);

      if (!isScrollable) {
        root.style.setProperty('--product-video-strip-progress', '0%');
        return;
      }

      const scrollRatio = maxScroll === 0 ? 0 : track.scrollLeft / maxScroll;
      const progress = 20 + scrollRatio * 80;
      root.style.setProperty('--product-video-strip-progress', `${progress}%`);
    };

    const mountStrip = (root) => {
      const track = root.querySelector(selectors.track);
      if (!track || root.dataset.videoStripMounted === 'true') return;

      root.dataset.videoStripMounted = 'true';

      const refresh = () => updateStrip(root);
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      requestAnimationFrame(refresh);
    };

    const init = () => {
      document.querySelectorAll(selectors.root).forEach(mountStrip);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
